import { render, staticRenderFns } from "./ProductAudit.vue?vue&type=template&id=47e4a2c7&scoped=true&"
import script from "./ProductAudit.vue?vue&type=script&lang=js&"
export * from "./ProductAudit.vue?vue&type=script&lang=js&"
import style0 from "./ProductAudit.vue?vue&type=style&index=0&id=47e4a2c7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e4a2c7",
  null
  
)

export default component.exports